import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {IoClose } from "react-icons/io5";
const useStyles = makeStyles((theme) => ({
    titre: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 600,
        color: 'rgba(32, 18, 70, 1)',
    },
    titreLabel: {
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 400,
        color: 'rgba(32, 18, 70, 1)',
    },
    TextContainer: {
        display: 'flex',
        justifyContent: 'space-between', 
        
    },
    cardTitle: {
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: 600,
        marginBottom: '10px',
    },
    cardText: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight : '21px',
        color: 'rgba(128, 128, 143, 1)',
        padding : '5px'
    },
    cardValue: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        fontWeight: 500,
        color: 'rgba(24, 28, 50, 1)',
        lineHeight : '21px' , 
        textAlign : 'Right',
        padding : '5px'
    },
    TextContainer: {
        display: 'flex',
        justifyContent: 'space-between',

    },
    dateRangeContainer: {
        display: 'flex',
        alignItems: 'center',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        padding: '5px 10px',
    },
    dateContainer: {
        border: 'none',
        outline: 'none',
        background: 'rgba(255, 255, 255, 1)',
        borderRadius: 5,
        fontFamily: 'Poppins',
        paddingLeft: '5px',
    },
    inputContainer: {
        border: '0.61px solid rgba(226, 217, 239, 1)',
        background: 'rgba(255, 255, 255, 1)',
        width: '148px',
        height: '29.69px',
        borderRadius: 5,
        marginLeft: '20px',
    },
    //CARDS:
    cardContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    },
    card: { 
        marginBottom: '20px',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
        border: 'none',
        boxSizing: 'border-box',
        
    },
    cardTitle: {
        fontFamily: 'Poppins',
        fontSize: '18px',
        fontWeight: 600,
        marginBottom: '10px',
        padding : '5px'
    },
    cardText: {
        fontFamily: 'Poppins',
        fontSize: '14px',
        color: 'rgb(128, 128, 143)',
        padding : '5px'
    },
    cardTextContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        textAlign: 'left',
    },
    caracteristic: {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 500,
        textAlign: 'right',
        color: 'rgba(24, 28, 50, 1)',
        display: 'inline',
    },
    cardTextParagraph: {
        margin: 4,
    },
}));

 const GarageCart = ({ filteredRepairers ,  designated , restDesignated  , width , height }) => {
     const [organizationDetails, setOrganizationDetails] = useState(null);
     //console.log("filteredRepairers", filteredRepairers)
     useEffect(() => {
        setOrganizationDetails(filteredRepairers);
     }, [filteredRepairers?.associatedParty]);
       // console.log("filteredRepairers", JSON.stringify(filteredRepairers.organization.partyCommunicationChannels))
     const getPhone = (partyCommunicationChannels) => {
        const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "PHONECONTACT" &&  party.status === "ACTIVE");
        const phoneValue = Channel ? Channel.communicationChannel.value : "N/A"
        return phoneValue
      }
    
    const getEmail = (partyCommunicationChannels) => {
        const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "EMAILCONTACT" &&  party.status === "ACTIVE");
        const emailValue = Channel ? Channel.communicationChannel.value : "N/A"
        return emailValue
      }
    
    const getAdresse = (partyAddresses) => {
        if(!partyAddresses){
            return "N/A"
        }
        const address = partyAddresses[0]?.address?.number+" "+ partyAddresses[0]?.address?.street+" "+partyAddresses[0]?.address?.state?.label+" "+partyAddresses[0]?.address?.postalCode?.postalCode
        if(address.includes("undefined")){
          return "N/A"
        }else {
          return address || {}
        }
      }
      function getGouvernorat(inspectorCaracteristiques) { 
        const Caracteristique = inspectorCaracteristiques?.find(item => item.key === "GOUVERNORAT" );
        const Gouvernorat = Caracteristique ? Caracteristique.value : "N/A"
        return Gouvernorat   
        }
     
    function getRegion(inspectorCaracteristiques) { 
        const Caracteristique = inspectorCaracteristiques?.find(item => item.key === "REGION" );
        const REGION = Caracteristique ? Caracteristique.value : "N/A"
        return REGION   
        }

    const classes = useStyles();
    const characteristicC0001 = filteredRepairers?.caracteristiques.find(c => c.key === 'c0001');
    const characteristicC0002 = filteredRepairers?.caracteristiques.find(c => c.key === 'c0002');
    const characteristicC0003 = filteredRepairers?.caracteristiques.find(c => c.key === 'c0003');
    return (
            <div className={classes.card}  
                onClick={designated} // Handle selection
                style={{  border: width === "100%" ? '0.61px solid rgba(226, 217, 239, 1)' : 'none'  ,width:width , height:height }}
                 >
                <div className={classes.TextContainer}>
                <div className={classes.cardTitle}>{organizationDetails?.organizationName}</div>
                {width === "100%" ?<IoClose  size={25}   style={{ color: 'rgba(187, 200, 8, 1)' ,cursor: 'pointer'}} onClick={restDesignated}/>:<></>}
             </div>
                 
            
            <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Gouvernorat :</div>
                                    <div className={classes.cardValue}>{getGouvernorat(filteredRepairers?.caracteristiques)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                <div className={classes.cardText}>Region : </div>
                                <div className={classes.cardValue}>{getRegion(filteredRepairers?.caracteristiques)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Adresse :</div>
                                    <div className={classes.cardValue}>{getAdresse(filteredRepairers?.organization?.partyAddresses)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Tel :</div>
                                    <div className={classes.cardValue}>{getPhone(filteredRepairers?.organization?.partyCommunicationChannels)}</div>
                        </div>
                        <div className={classes.TextContainer}>
                                    <div className={classes.cardText}>Email  :</div>
                                    <div className={classes.cardValue}>{getEmail(filteredRepairers?.organization?.partyCommunicationChannels)}</div>
                        </div>
            <div className={classes.cardText}>
                {/* <div className={classes.cardTextContainer}>
                    <p className={classes.cardTextParagraph}>Nombre de mission en cours/capacité:</p>
                    <span
                        className={classes.caracteristic}>{filteredRepairers?.performanceKpi?.missionsInProgress}/10</span>
                </div>
                <div className={classes.cardTextContainer}>
                    <p className={classes.cardTextParagraph}>Total véhicule même marque réparés:</p>
                    <span
                        className={classes.caracteristic}>{characteristicC0002 ? characteristicC0002.value : 'N/A'}</span>
                </div>
                <div className={classes.cardTextContainer}>
                    <p className={classes.cardTextParagraph}>Taux horaire réparation:</p>
                    <span
                        className={classes.caracteristic}>{characteristicC0001 ? characteristicC0001.value : 'N/A'}</span>
                </div>
                <div className={classes.cardTextContainer}>
                    <p className={classes.cardTextParagraph}>Taux horaire remplacement:</p>
                    <span
                        className={classes.caracteristic}>{characteristicC0003 ? characteristicC0003.value : 'N/A'}</span>
                </div>
                <div className={classes.cardTextContainer}>
                    <p className={classes.cardTextParagraph}>Cout moyen / sinistre:</p>
                    <span
                        className={classes.caracteristic}>{filteredRepairers?.performanceKpi?.averageReparationCost} TND</span>
                </div> */}

            </div>
        </div>
    )

}

export default GarageCart;